module.exports = __webpack_public_path__ + "static/videosolhd-2e0200c4eba12d8d47598c5f43fc8e71.mp4";